import React, { useState } from 'react'
import { Modal, message } from 'antd';
import { DropzoneArea } from 'material-ui-dropzone';
import { useHistory } from "react-router-dom";

import { url } from "../Constent/Constant";

const ServiceCards = ({ CardData, UpdateImage, UpdateText }) => {
    const [HeadingUpdate, setHeadingUpdate] = useState('')
    const [TextModalVisible, setTextModalVisible] = useState(false);
    const [ImageUpdate, setImageUpdate] = useState(null)
    const [ImageModal, setImageModal] = useState(false);
    const [UpdateId, setUpdateId] = useState('')
    const history = useHistory()


    const ShowTextModal = (id) => {
        setTextModalVisible(true);
        setUpdateId(id)
    };

    const showImageModal = (id) => {
        setImageModal(true);
        setUpdateId(id)
    };


    const TextHandle = () => {
        if (HeadingUpdate === '') {
            message.error('Fill the Field')
        } else {
            UpdateText({
                text: HeadingUpdate,
                id: UpdateId
            })
            setTextModalVisible(false);
            setHeadingUpdate('')
        }
    };

    const OnImageHandle = () => {
        if (ImageUpdate === null) {
            message.error('Insert Image')
        } else {
            UpdateImage({
                image: ImageUpdate,
                id: UpdateId
            })
            setImageModal(false);
        }
    };

    const handleCancel = () => {
        setTextModalVisible(false);
        setImageModal(false);
    };

    const OnEnterPress = (event) => {
        const a = HeadingUpdate
        console.log(a)
        if (event.key === 'Enter') {
            console.log('Enter Clicked')
            a.concat('\n')
            setHeadingUpdate(a)
        } else {
            console.log(event.key)
        }
    }


    return (
        <div className='Service-Card-Container'>
            <h2 className='Heading'> {CardData ? CardData.section3heading1.content : 'No Text'}
                <i onClick={() => ShowTextModal(CardData.section3heading1._id)} className="far fa-edit Edit-btn"></i>
            </h2>
            <p> {CardData ? CardData.section3paragraph1.content : 'No Text'}
                <i onClick={() => ShowTextModal(CardData.section3paragraph1._id)} className="far fa-edit Edit-btn"></i>
            </p>
            <div className='Service-Cards'>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <i onClick={() => showImageModal(CardData.section3image1._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.section3image1.image}`} alt='icon' draggable='false' />
                    </div> */}
                    <h3>{CardData ? CardData.section3heading2.content : 'No Text'}
                        <i onClick={() => ShowTextModal(CardData.section3heading2._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(CardData.section3paragraph2._id)} className="far fa-edit Edit-btn"></i>
                        <p>{CardData ? CardData.section3paragraph2.content : 'No Text'}</p>
                    </div>
                    <button className='Primary-btn' onClick={() => history.push('/LocalMoving')}> Learn More </button>

                </div>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <i onClick={() => showImageModal(CardData.section3image2._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.section3image2.image}`} alt='icon' draggable='false' />
                    </div> */}
                    <h3>{CardData ? CardData.section3heading3.content : 'No Text'}
                        <i onClick={() => ShowTextModal(CardData.section3heading3._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(CardData.section3paragraph3._id)} className="far fa-edit Edit-btn"></i>
                        <p>{CardData ? CardData.section3paragraph3.content : 'No Text'}</p>
                    </div>
                    <button className='Primary-btn' onClick={() => history.push('/LongDistanceMoving')}> Learn More </button>

                </div>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <i onClick={() => showImageModal(CardData.section3image3._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.section3image3.image}`} alt='icon' draggable='false' />
                    </div> */}
                    <h3>{CardData ? CardData.section3heading4.content : 'No Text'}
                        <i onClick={() => ShowTextModal(CardData.section3heading4._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(CardData.section3paragraph4._id)} className="far fa-edit Edit-btn"></i>
                        <p>{CardData ? CardData.section3paragraph4.content : 'No Text'}</p>
                    </div>
                    <button className='Primary-btn' onClick={() => history.push('/CommercialMoving')}> Learn More </button>
                </div>
                <div className='Card'>
                    {/* <div className='Image-div'>
                        <i onClick={() => showImageModal(CardData.section3image4._id)} className="far fa-edit Edit-btn"></i>
                        <img src={`${url}/api/getFile${CardData.section3image4.image}`} alt='icon' draggable='false' />
                    </div> */}
                    <h3>{CardData ? CardData.section3heading5.content : 'No Text'}
                        <i onClick={() => ShowTextModal(CardData.section3heading5._id)} className="far fa-edit Edit-btn"></i>
                    </h3>
                    <div className='Para-div'>
                        <i onClick={() => ShowTextModal(CardData.section3paragraph5._id)} className="far fa-edit Edit-btn"></i>
                        <p>{CardData ? CardData.section3paragraph5.content : 'No Text'}</p>
                    </div>
                    <button className='Primary-btn' onClick={() => history.push('/Storage')}> Learn More </button>

                </div>
            </div>

            {/* Update Text Modal */}
            <Modal width={400} style={{ top: '30%' }} title='Update Text' visible={TextModalVisible} onOk={TextHandle} onCancel={handleCancel} okText="Update" >
                <textarea onKeyPress={(e) => OnEnterPress(e)} value={HeadingUpdate} onChange={e => setHeadingUpdate(e.target.value)} className='Input' placeholder='Update Heading...' />
            </Modal>

            {/* Update Image Modal */}
            <Modal width={700} style={{ top: '5%' }} title='Update Image' visible={ImageModal} onOk={OnImageHandle} onCancel={handleCancel} okText="Update" >
                <DropzoneArea
                    filesLimit={1}
                    acceptedFiles={['image/*']}
                    dropzoneText={"Update Product Images"}
                    onChange={(files) => {
                        console.log('Files:', files[0])
                        setImageUpdate(files[0])
                    }}
                />
            </Modal>


        </div>

    )
}

export default ServiceCards
